<template>
    <div class="w-100 h-100 container-tsied" v-show="ready">

        <div class="page-content">
            <div class="login-box">
                <div class="login-table text-white">
                    <div class="text-center h5 mt-3">
                        登 录 | SIGN IN
                    </div>
                    <div class="line"></div>
                    <form action="/" @submit.prevent="submitForm" class="px-3 py-3">
                        <div class="form-group color-white">
                            <label>用户名/学工号</label>
                            <input type="text" v-model="login.id" class="form-control"
                                   placeholder="用户/邮箱" required>
                        </div>
                        <div class="form-group color-white">
                            <div>
                                <div class="pull-right mb-3">
                                    <a href="javascript:void(0);" @click="resetPassword">
                                        <small>忘记或重置密码</small>
                                    </a>
                                </div>
                                密码
                            </div>
                            <input type="password" v-model="login.password"
                                   placeholder="密码" class="form-control" required>
                        </div>

                        <div class="form-check color-white text-right mb-3">
                            <a href="javascript:void(0);" @click="jumpToWechatCorp" class="sigin-a">
                                <small><i class="fa fa-link"></i> 企业扫码登录，请点击此处</small>
                            </a>
                        </div>

                        <div>
                            <button type="submit" class="btn btn-primary btn-block" :disable="process.loading">登 录
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="mt-2" style="font-size: 1em;color: #eee;height: 25%;">韬视信息技术视频云平台</div>

        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import qywxCommon from "../common/mixins/qywxCommon"

    let vm = null;

    export default {
        name: "sign-in",
        mixins:[qywxCommon],
        data() {
            return {
                ready: false,
                error_message: 'error message',
                show_login_error: false,
                login: {
                    id: '',
                    password: ''
                },
            }
        },
        created() {
            vm = this;
        },
        mounted() {
            this.qywxWebLogHandler();
        },
        computed: {
            ...mapState(['user', 'process']),

        },
        methods: {
            ...mapMutations('user', ['setUserInfo']),
            resetPassword() {
                if (vm.login.id) {
                    vm.$affirm('我们将向您的邮箱发送一份包含有密码的邮件, 是否继续?').then(() => {
                        vm.$api('ResetPassword', vm.login, true).then(() => {
                            vm.$messageBox.success('密码已经发出，请检查您的邮箱。');
                        })
                    })
                } else {
                    vm.$notice.error('请重新输入用户/邮箱');
                }
            },
            submitForm() {
                if (!vm.login.id) {
                    vm.$notice.error('请重新输入用户/邮箱');
                } else {
                    vm.$api('SignIn', vm.login, true).then(response => {
                        vm.setUserInfo(response.data.data);
                        vm.$router.replace("/");
                    });
                }
            },
            jumpToWechatCorp() {
                window.location.href = this.$organization.wx_redirect;
            },
            jumpToSignIn() {
                this.$router.push('/sign-in');
                this.show_login_error = false;
                this.ready = true;
            }
        },

    }
</script>

<style lang="scss">

    .container-tsied {
        background: url('/assets/images/tsied-login-bg.jpg') no-repeat center midnightblue;
        background-size: cover;

        .page-content {
            display: flex;
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .login-box {
                width: 300px;
                min-height: 300px;
                background-color: rgba(255, 255, 255, 0.3);
                border: 1px solid rgba(255, 255, 255, 0.9);
                border-radius: 10px;

                a {
                    color: #ffcc80;
                    text-decoration: none;
                    transition: color ease-in 0.2s;

                    &:hover {
                        color: #fff;
                    }
                }
            }
        }

        .flex-in-middle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
        }
    }

</style>
